/**
 * A file picked on any platform.
 *  - native: `{ uri, name, type }` — React Native's FormData uploads it from the uri
 *  - web: `file` holds the browser File/Blob, `uri` is an object URL for previews
 */
export interface UploadFile {
  uri: string;
  name: string;
  type: string;
  size?: number;
  file?: Blob;
}

/** Appends a picked file to FormData the way the current platform expects. */
export function appendFile(fd: FormData, key: string, f: UploadFile | null | undefined) {
  if (!f) return;
  if (f.file) fd.append(key, f.file, f.name);
  else fd.append(key, { uri: f.uri, name: f.name, type: f.type } as unknown as Blob);
}
